import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=a9f0be60&lang=pug&"
import script from "./Sponsor.vue?vue&type=script&lang=ts&"
export * from "./Sponsor.vue?vue&type=script&lang=ts&"
import style0 from "./Sponsor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports